export default {
  cart: 'cart'
}
